import { Description, SubTitle } from "Components/CustomComponents";
import React, { useEffect } from "react";
import { TriangleIcon } from "svg";
import ModalContainer from "../ModalContainer";
import cssStyles from "./styles/notification.module.scss";
import { useLazyGetNotificationQuery } from "Data/services/dashbaordApi";
import CustomLoader from "Components/CustomComponents/CustomLoader";
import _ from "lodash";
import NoDataFound from "Components/CustomComponents/NoDataFound";
import { NotificationProps } from "Data/interfaces";

interface NotificationModalProps {
  handleNotificationModalClose: () => void;
}

const NotificationModal: React.FC<NotificationModalProps> = ({
  handleNotificationModalClose,
}) => {
  // const handleMarked = () => {
  //   console.log("handleMarked");
  // };

  const [getNotifications, { data, isFetching }] =
    useLazyGetNotificationQuery();
  // console.log(isFetching);
  // console.log(data);

  useEffect(() => {
    getNotifications();
  }, []);

  return (
    <div>
      <ModalContainer
        handleClose={handleNotificationModalClose}
        dropShadow={true}
      >
        <div className={cssStyles.modalContainer}>
          <div className={cssStyles.triangle}>
            <TriangleIcon />
          </div>
          {isFetching ? (
            <CustomLoader />
          ) : _.isEmpty(data?.data) ? (
            <NoDataFound />
          ) : (
            <div
              className={`d-flex flex-column w-100 gap-3 pt-3 ${cssStyles.contentArea}`}
            >
              {data?.data.map((notification) => Notification(notification))}
            </div>
          )}
        </div>
      </ModalContainer>
    </div>
  );

  function Notification(notification: NotificationProps) {
    return (
      <div className="d-flex  w-100 align-items-stretch justify-content-between">
        <div className="d-flex" style={{ width: "300px" }}>
          <div
            className=" rounded-5 d-flex justify-content-center"
            style={{
              backgroundColor: "#222232",
              width: "50px",
              height: "50px",
            }}
          >
            <img
              src={notification.driver_record.image_url}
              className={cssStyles.image}
              alt=""
            />
          </div>

          <div className="ms-3">
            <SubTitle
              text={`${notification.driver_record.firstname} ${notification.driver_record.lastname}`}
              classes="mb-05"
            />
            <Description
              text={
                <>
                  Truck No:{" "}
                  <span className="fw-bold">
                    {notification.driver_record.truck_no}
                  </span>
                </>
              }
            />
            <Description text={notification.type} classes="exception mt-2" />
            <Description text={notification.message} classes="lc-2 fw-light" />
          </div>
        </div>

        {/* <div className="d-flex  align-items-center" onClick={handleMarked}>
          <span className={`${cssStyles.markResolved}`}>{"Mark Resolved"}</span>
        </div> */}
      </div>
    );
  }
};

export default NotificationModal;
